module.exports = __webpack_public_path__ + "static/media/creed.50f22db1.jpg";